import { HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { BackendService } from "src/app/core/services/backend-service";
import {
  FeedbackInterface,
  FeedbackBaseRequest,
  FeedbackRequest
} from "../../../core/interfaces/feedback-interface";
import { UserStore } from "../../store/user-store";

@Injectable({
  providedIn: "root",
})
export class FeedbackService extends BackendService {
  private readonly userStore = inject(UserStore);

  downloadFeedbacks(): Promise<HttpResponse<Blob>> {
    return this.downloadBlob("api/feedbacks/download");
  }

  postFeedback(feedbackBaseRequest: FeedbackBaseRequest): Promise<FeedbackInterface> {

    const feedbackRequest : FeedbackRequest = {
      ...feedbackBaseRequest,
      delegationId: this.userStore.getUserDelegationId(),
      divisionId: this.userStore.getUserDivisionId(),
      areaId: this.userStore.getUserAreaId(),
      divisionName: this.userStore.divisionName(),
      areaName: this.userStore.areaName(),
      delegationName: this.userStore.delegationName()
    };
  
    return this.post<FeedbackRequest, FeedbackInterface>(
      "api/feedbacks",
      feedbackRequest
    );
  }
}
